import Modal from '@lib/core/src/components/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Stack } from '@mui/material';

import Integrations from '@/components/Integrations/Integrations';
import { useIsSmallScreen } from '@/utils/mediaUtil';

import { ComingSoon, Title, Wrapper } from './IntegrationsModalStyles';

interface IntegrationsModalProps {
  onClose: () => void;
  open: boolean;
}

const IntegrationsModal = ({ onClose, open }: IntegrationsModalProps) => {
  const isSmallScreen = useIsSmallScreen();

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        height: { xs: '95vh', md: '95vh', lg: '61vh', width: isSmallScreen ? '100vw' : 'auto' }
      }}
    >
      <Stack sx={{ height: '100%', gap: { md: 3, lg: 5 } }}>
        <Stack direction="row" alignItems="start" justifyContent="space-between">
          <Wrapper>
            <Title>Integrations</Title>
            <ComingSoon>In order to help us utilize and maximize your insights</ComingSoon>
          </Wrapper>
          <IconButton onClick={onClose}>
            <CloseIcon sx={{ width: '20px', height: '20px' }} />
          </IconButton>
        </Stack>
        <Integrations />
      </Stack>
    </Modal>
  );
};

export default IntegrationsModal;
